import {
  BookNote,
  CreateBookNote,
  GetListResponse,
  UpdateBookNote,
} from "@app/types";
import HttpService from "@core/services/http/http.service";
import { RequestParams, Signal } from "@core/services/http/http.type";

class _BookNoteService {
  public getList(requestParams?: RequestParams, signal?: Signal) {
    return HttpService.get<GetListResponse<BookNote>>(
      "/user/api/v2/book-notes",
      {
        queryParams: { ...requestParams },
        signal,
      }
    );
  }

  public createNote(payload: CreateBookNote) {
    return HttpService.post("/user/api/v2/book-notes", {
      body: { ...payload },
    });
  }

  public updateNote(elementId: number, payload: UpdateBookNote) {
    return HttpService.patch(`/user/api/v2/book-notes/${elementId}`, {
      body: { ...payload },
    });
  }

  public deleteNote(elementId: number) {
    return HttpService.delete(`/user/api/v2/book-notes/${elementId}`);
  }
}

const BookNoteService = new _BookNoteService();

export default BookNoteService;
